<ng-container>
  <button
    type="button"
    [disabled]="disabled()"
    [ngStyle]="{
      'background-color': bgColor,
      border: borderColor,
      color: textColor
    }"
    (click)="handleClick()"
    class="flex items-center justify-center gap-2 px-5 py-3 bg-gradient-to-r from-primary-500 to-primary-600 text-white font-medium text-sm rounded-lg hover:from-primary-600 hover:to-primary-700 transition-all duration-200 shadow-primary hover:shadow-primary-lg disabled:opacity-50 disabled:cursor-not-allowed"
  >
    @if (!isLoading()) {
      <ng-content></ng-content>
      {{ text() }}
    }
    @if (isLoading()) {
      <span class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
    }
  </button>
</ng-container>
